import React from 'react';
import { FaCogs } from 'react-icons/fa';
import styles from './ConstantManagementPage.module.css';
import { useTheme } from '../contexts/ThemeContext';
import './ConstantManagementDarkMode.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ConstantManagementPage = () => {
  const { isDarkMode } = useTheme();
  const [activeModal, setActiveModal] = React.useState(null);
  
  const cards = [
    { 
      title: 'Sabit Yönetimi', 
      icon: <FaCogs />, 
      color: '#00bcd4', 
      description: 'Sistem sabitleri ve parametrelerin yönetimi'
    }
  ];

  const handleCardClick = (title) => {
    // For now just show toast, later can implement specific modals
    toast.info(`${title} modülü yakında kullanıma sunulacaktır.`);
  };

  return (
    <div className={`${styles.pageContainer} ${isDarkMode ? 'dark-mode' : ''}`}>
      <div className={styles.container}>
        {/* Header Section */}
        <header className={styles.header}>
          <div className={styles.headerContent}>
            <h1 className={styles.title}>
              <FaCogs className={styles.headerIcon} />
              Sabit Yönetimi
            </h1>
          </div>
        </header>

        {/* Cards Grid */}
        <div className={styles.cardsContainer}>
          {cards.map((card, index) => (
            <div 
              key={index} 
              className={`${styles.card} ${styles.singleCard}`}
              onClick={() => handleCardClick(card.title)}
              data-color={card.color}
            >
              <div className={styles.cardColor} style={{ backgroundColor: card.color }}></div>
              <div className={styles.cardContent}>
                <div className={styles.cardHeader}>
                  <div className={styles.cardIconWrapper} style={{ backgroundColor: `${card.color}20` }}>
                    <div className={styles.cardIcon} style={{ color: card.color }}>
                      {card.icon}
                    </div>
                  </div>
                  <div className={styles.cardInfo}>
                    <h2 className={styles.cardTitle}>{card.title}</h2>
                    <p className={styles.cardDescription}>{card.description}</p>
                  </div>
                </div>
                <div className={styles.cardFooter}>
                  <div className={styles.cardArrow}>&#8594;</div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ConstantManagementPage;
